import { Grid } from '../../componentes/grid'

export function Progreso() {
    return (
        <>
            <article>
                <div className="wrapper mx-auto">
                    <img src="/assets/img/progreso/progreso.png" alt="Sweet Palermo" />
                </div>
                <Grid className="my-8" />
            </article>
        </>
    )
}
